import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const SkeletonWrapper = styled.div`
  width: 584px;
  border-top: 1px solid #EBEBEB;
  padding: 24px 0 16px;

  @media (max-width: 1024px) {
    width: 100%;
  }
`
